import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

// Components
import Hero from './components/Hero';
import G163Hero from 'src/universal/components/Experiments/G163';

// Utils/Constants
import { sendDTMEvent } from 'src/universal/utils/analyticsTracking';
import { useBreakpoint } from '@americanexpress/aqx-components';

// Selectors
import { getIsGoldCard, getIsPlatinumCard, getIsDeltaReserve } from './redux';
import { getHeroDtmEvents } from 'page_modules/business-pdp/redux';
import { isG163Variant } from 'src/universal/components/Experiments/G163/redux';
import { hasOneXpRequestFinished } from 'src/universal/redux/oneXp';

// styles
import styles from './__styles__/index.scss?modules';

const HeroWrapper = ({
  dtmEvents,
  isPlatinumCard,
  isGoldCard,
  shortName,
  isDeltaReserve,
  isG163,
  oneXpDecided
}) => {
  const { scrollButtonClick } = dtmEvents;

  const { sm } = useBreakpoint();

  const heroRef = useRef(null);

  const onClick = () => {
    if (heroRef) {
      const { bottom } = heroRef.current.getBoundingClientRect();
      const targetY = bottom;
      window.scrollBy({ left: 0, top: targetY, behavior: 'smooth' });
      sendDTMEvent({ dtmObj: scrollButtonClick });
    }
  };

  useEffect(
    () => {
      const clsName = 'fullPageHero';

      if (isGoldCard) {
        document.body.classList.add(clsName);
      } else {
        document.body.classList.remove(clsName);
      }

      return () => {
        document.body.classList.remove(clsName);
      };
    },
    [isGoldCard]
  );

  if (!isGoldCard && !isPlatinumCard && !isDeltaReserve) {
    return null;
  }
  let nonPremiumCard = false;
  if (!isGoldCard && !isPlatinumCard && !isDeltaReserve) {
    nonPremiumCard = true;
  }

  if (isPlatinumCard && sm && !oneXpDecided) {
    return <div className={styles.placeHolder} />;
  }

  if (isPlatinumCard && sm && isG163) {
    return <G163Hero />;
  }

  return (
    <div ref={heroRef}>
      <Hero
        onClick={onClick}
        shortName={shortName}
        isNonPremiumCard={nonPremiumCard}
      />
    </div>
  );
};

const mapStateToProps = state => {
  return {
    dtmEvents: getHeroDtmEvents(state),
    isGoldCard: getIsGoldCard(state),
    isPlatinumCard: getIsPlatinumCard(state),
    isDeltaReserve: getIsDeltaReserve(state),
    isG163: isG163Variant(state),
    oneXpDecided: hasOneXpRequestFinished(state)
  };
};

export default connect(mapStateToProps)(HeroWrapper);
